/* eslint-disable no-unused-vars */
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import { useHead } from '#imports'

export type AxeptioChoices = Record<string, boolean>
export interface AxeptioSDK {
  on: (event: string, callback: (choices: AxeptioChoices) => void) => void
  requestConsent: (choice: string) => void
  userPreferencesManager: {
    choices: AxeptioChoices
  }
}

declare global {
  interface Window {
    _axcb?: ((axeptio: AxeptioSDK) => void)[]
    axeptioSettings?: {
      clientId: string
      cookiesVersion: string
    }
  }
}

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  if (import.meta.client) {
    window.axeptioSettings = {
      clientId: runtimeConfig.public.axeptioClientId,
      cookiesVersion: 'jeveuxaider-base',
    }

    window._axcb ??= []
  }

  useHead({
    script: [
      {
        src: '//static.axept.io/sdk.js',
        async: true,
      },
    ],
  })
})
